import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "./dropdownDirective.scss";

angular.module("ticketco/common")
  .directive("tippyDropdown", function ($timeout) {
    return {
      link: function (scope, elem, attrs) {
        let tippyInstance;

        $timeout(() => {
          const id = attrs.template;
          const template = document.getElementById(id);
          const tippyDropdownElements = template.querySelectorAll('.tippy-dropdown-item a');

          tippyInstance = tippy(elem[0], {
            content(reference) {
              return template;
            },
            appendTo: () => document.body,
            trigger: "click",
            hideOnClick: "toggle",
            allowHTML: true,
            interactive: true,
            animation: "fade",
            placement: "bottom-end",
            arrow: false,
            offset: [0, 0],
            theme: "dropdown",
            onShown(instance) {
              tippyDropdownElements.forEach(item => {
                item.addEventListener('click', () => instance.hide());
              });
            },
            onHide(instance) {
              tippyDropdownElements.forEach(item => {
                item.removeEventListener('click', () => instance.hide());
              });
            },
          });
        });

        scope.$on("$destroy", function () {
          if (tippyInstance) {
            tippyInstance.destroy();
          }
        });
      },
    };
  });
